
import { AccountPensionInformationClient } from "../../../../../../../../Wrap/Api/Account/AccountPensionInformation";
import { SIPPOverviewProductClient } from "../MockAPI";

export class ProductOverviewSippPensionInformationAction {
    public static get(hierarchyId: string, callback) {
        const client = new AccountPensionInformationClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((data) => {callback(data)});

        promise.onError(() => {});        
    }
}